import React from "react";
import tw from "tailwind-styled-components";
import { Text } from "@components";
import { useTranslation } from "react-i18next";

function NoData(props) {
  const { t } = useTranslation("common")
  return (
    <Container>
      <Text className={`text-[28px] text-center font-bold ${props?.className}`}>
        {props?.data || t("common.no_Data")}
      </Text>
    </Container>
  );
}

const Container = tw.div`
flex 
justify-center
items-center
w-[100%]
h-[150px]
`;

export default NoData;
